import { Component, OnInit } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { AlertController } from '@ionic/angular';
import { WebParameterContext } from '../../../../model/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
declare var app;
@Component({
  selector: 'app-mz-leave-approval-detail',
  templateUrl: './mz-leave-approval-detail.component.html',
  styleUrls: ['./mz-leave-approval-detail.component.scss']
})
export class MzLeaveApprovalDetailComponent extends GridBaseCase {
arrayobj:any={};
ID:any;
isRole:boolean = false;//是否管理层
  constructor(
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    private alertController:AlertController
    ) { super(); }

  LoadData() {
    let that = this;
    try{
      if(that.com.GetAccount.Roles){
        that.com.GetAccount.Roles.forEach(role=>{
          if(role.Code=="1007"){//如果是管理层不可审批
            that.isRole=true;
          }
        });
      }
    }catch(err){
        console.log(err);
    }
    that.loading = false;
    that.apiObj['status'] = false;
    that.apiObj['msg'] = '';
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    that.ID = that.activaRouter.snapshot.paramMap.get("id").split('&');
    let body = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 1;
    body.PageNumber = 1
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    body.RequestBody = JSON.stringify({"a_ID": that.ID[0]});
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          // let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              if(element.bindingField=="pic"){
                if(item[element.field]){
                  let tempimg:any=null;
                  let imgpic:Array<any> = item[element.field].split(',');
                  imgpic.forEach((pic)=>{
                     if(!tempimg){
                      tempimg = (app.FileUoloadUrl+pic).replace(app.ImagePlaceholder,app.SmallImageType);
                     }else{
                      tempimg += ","+(app.FileUoloadUrl+pic).replace(app.ImagePlaceholder,app.SmallImageType);
                     }
                  });
                  that.arrayobj[element.bindingField] = { "value": tempimg, "text": element.text };
                }
               
                 
              }else{
                that.arrayobj[element.bindingField] = { "value": item[element.field], "text": element.text };
              }
               
            }
          });
          console.log(that.arrayobj);
          //判断图片是否存在

          //console.log(that.dataArrayList);
        });
      }else{

        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }

    }).catch(error => {
      console.log(error);
    })
  }

  EventClickadop(event,remark:any = ""){
    const that=this;
    let webcontext:WebParameterContext  =new WebParameterContext();
        webcontext.Account = that.com.GetAccount;
        webcontext.ConfigName ="LeaveXML";
        webcontext.ConfigType ="form";
        webcontext.OpType = "edite";
        webcontext.ID = that.com.GetAccount.Id;
        let objchilren={};
            objchilren["CHILDOBJ_TypeOfLeaveSysUserXML"]={"Info":{"FormFKElementModel":"a_FK_Leave_ID","ProviderFKElementModel":"a_ID","FormConfigName":"TypeOfLeaveSysUserXML"},"Datas":[]};
            let obj={};
                objchilren["a_ID"]= that.ID[0];//主表ID
              if(event){
                objchilren["a_AuditStatus"]=1;//审核通过，一个人审核则审核通过
                objchilren["CHILDOBJ_TypeOfLeaveSysUserXML"].Datas.push({"a_ID":that.ID[1],"a_AuditStatus":1,});
              }else{
                objchilren["a_AuditStatus"]=2;//审核驳回，一个人审核则审核驳回
                objchilren["CHILDOBJ_TypeOfLeaveSysUserXML"].Datas.push({"a_ID":that.ID[1],"a_AuditStatus":2,"a_Remarks":remark});
              }
              webcontext.RequestBody=JSON.stringify(objchilren);
              // console.log(webcontext.RequestBody);
              that.http.post(app.DEFAULTURL,webcontext).then(data=>{
                 if(data.ResponseMessage.Success){
                  that.com.removeBack();
                  // that.router.navigate(['/tabs/contact/LeaveApprovalList/'+that.ID[0]]);
                  that.com.Go('/tabs/contact/LeaveApprovalList/'+that.ID[0]);
                 }else{
                   that.msg.Alert(data.ResponseMessage.ErrorMessage);
                 }
              });
      

  }
  async presentAlertPrompt() {
    const that = this;
    const alert = await this.alertController.create({
      header: '驳回理由',
      mode:"ios",
      inputs: [
        {
          name: 'reason',
          type: 'text',
          placeholder: '请输入驳回理由'
        }
      ],
      buttons: [
        {
          text: '取消',
          role: 'cancel',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: '提交',
          handler: (data) => {
            console.log(data,'Confirm Ok');
            that.EventClickadop(false,data.reason);
          }
        }
      ]
    });

    await alert.present();
  }

  imgPreview(img) {
    let that = this;
    let url = img.trim().replace(app.SmallImageType,app.BigImageType);
    let ImgPreview = {
      imgUrl:[url],
      index:1
    }
    // localStorage.setItem("ImgPreview",JSON.stringify(ImgPreview));
    // that.router.navigate(["/tabs/contact/ImgPreview"]);
    that.com.Go("/tabs/contact/ImgPreview",{
      ImgPreview:JSON.stringify(ImgPreview)
    });
    // that.router.navigate(["/tabs/contact/ImgPreview"],{
    //   queryParams:{
    //     ImgPreview:JSON.stringify(ImgPreview)
    //   }
    // });
  }
}
